import BasePage from "./BasePage";
import Link from "next/link";

function PagePrivacyPolicy() {
  return (
    <BasePage>
      <main className="mx-auto min-h-[34.625rem] max-w-screen-lg bg-slate-100  px-4 py-8 text-left sm:min-h-[41.375rem] sm:px-6 md:min-h-[52.5625rem]">
        <Breadcrumbs />
        {/* <Hero /> */}
        <div className="max-w-screen-sm rounded-lg bg-white p-6 text-sm leading-relaxed">
          <div className="mb-4 text-xl font-semibold">Privacy Policy</div>
          <p className="mb-4">
            Your privacy is very important to us. Accordingly, we have developed
            this Policy in order for you to understand how we collect, use,
            communicate and make use of personal information. The following
            outlines our Privacy Policy.
          </p>
          <p className="mb-4">
            When accessing our Website, our marketing platforms will learn
            certain information about you during your visit.
          </p>
          <p className="mb-4">
            Similar to other commercial Web sites, our Web site utilises a
            standard technology called "cookies" (see explanation below)
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">What Are Cookies?</h2>
          <p className="mb-4">
            A cookie is a very small text document, which often includes an
            anonymous unique identifier. When you visit a Web site, that site's
            computer asks your computer for permission to store this file in a
            part of your hard drive specifically designated for cookies. Each
            Web site can send its own cookie to your browser if your browser's
            preferences allow it, but (to protect your privacy) your browser
            only permits a Web site to access the cookies it has already sent to
            you, not the cookies sent to you by other sites.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            What Types Of Personal Information Do We Collect?
          </h2>
          <p className="mb-4">
            We may collect the following types of personal information:
          </p>
          <ul>
            <li className="mb-4 list-inside list-disc">
              First name and last name;
            </li>
            <li className="mb-4 list-inside list-disc">Email address;</li>
            <li className="mb-4 list-inside list-disc">
              Age or year of birth;
            </li>
            <li className="mb-4 list-inside list-disc">
              Your device ID, device type, geo-location or timezone information,
              computer and connection information, statistics on page views,
              traffic to and from the sites, ad data, IP address and standard
              web log information;
            </li>
            <li className="mb-4 list-inside list-disc">
              Any additional information relating to you that you provide to us
              directly through our website or app or indirectly through your use
              of our website or app or online presence or through other websites
              or accounts from which you permit us to collect information;
            </li>
            <li className="mb-4 list-inside list-disc">
              Information you provide to us through customer surveys; or
            </li>
            <li className="mb-4 list-inside list-disc">
              any other personal information that may be required in order to
              facilitate your dealings with us.
            </li>
          </ul>
          <p className="mb-4">
            We may collect these types of personal information either directly
            from you, or from third parties. We may collect this information
            when you:
          </p>
          <ul>
            <li className="mb-4 list-inside list-disc">
              Register on our website or app;
            </li>
            <li className="mb-4 list-inside list-disc">
              Communicate with us through correspondence, chats, email, or when
              you share information with us from other social applications,
              surveys, services or websites; or
            </li>
            <li className="mb-4 list-inside list-disc">
              Engage with our sites, services, content and advertising.
            </li>
          </ul>
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            Why Do We Collect, Use &amp; Disclose Personal Information?
          </h2>
          <p className="mb-4">
            We may collect, hold, use and disclose your personal information for
            the following purposes:
          </p>
          <ul>
            <li className="mb-4 list-inside list-disc">
              to enable you to access and use our website or services;
            </li>
            <li className="mb-4 list-inside list-disc">
              to operate, protect, improve and optimise our website, content or
              service;
            </li>
            <li className="mb-4 list-inside list-disc">
              to operate, protect, improve and optimise our business’ and our
              users’ experience, perform analytics, conduct research and for
              advertising and marketing;
            </li>
            <li className="mb-4 list-inside list-disc">
              to send you service, support and administrative messages,
              reminders, technical notices, updates, security alerts, and
              information requested by you;
            </li>
            <li className="mb-4 list-inside list-disc">
              to send you marketing and promotional messages and other
              information that may be of interest to you, including information
              sent by, or on behalf of, our business partners that we think you
              may find interesting;
            </li>
            <li className="mb-4 list-inside list-disc">
              to administer rewards, surveys, contests, or other promotional
              activities or events sponsored or managed by us or our business
              partners; and
            </li>
            <li className="mb-4 list-inside list-disc">
              to comply with legal obligations, resolve any disputes that we may
              have with any of our users, and enforce our agreements and
              partnerships with third parties.
            </li>
          </ul>
          <p className="mb-4">
            We may also disclose your personal information to trusted third
            parties who also holds other information about you based on your
            online and digital engagement.
          </p>
          <p className="mb-4">
            These third parties may combine that information from multiple
            sources in order to enable them and us to develop anonymised
            consumer insights so that we can better understand your preferences
            and interests, personalise your experience and enhance the products,
            services and advertising that you receive.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">IP Addresses</h2>
          <p className="mb-4">
            IP addresses are used by your computer every time you are connected
            to the Internet. Your IP address is a number that is used by
            computers on the network to identify your computer. IP addresses are
            automatically collected by our web server as part of demographic and
            profile data known as “traffic data” so that data (such as the Web
            pages you request) can be sent to you.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">Email Information</h2>
          If you choose to correspond with us through email, we may retain the
          content of your email messages together with your email address and
          our responses. We provide the same protections for these electronic
          communications that we employ in the maintenance of information
          received online.
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            How Do We Use the Information That You Provide to Us?
          </h2>
          <p className="mb-4">
            Broadly speaking, we use personal information for purposes of
            administering our business activities, providing customer service,
            and making available other items and services to our customers and
            prospective customers.
          </p>
          <p className="mb-4">
            We will not obtain personally-identifying information about you when
            you visit our site unless you choose to provide such information to
            us, nor will such information be sold or otherwise transferred to
            unaffiliated third parties without the approval of the user at the
            time of collection.
          </p>
          <p className="mb-4">
            We may disclose information when legally compelled to do so, in
            other words, when we, in good faith, believe that the law requires
            it or for the protection of our legal rights.
          </p>
          <p className="mb-4">
            If you have any queries regarding this data or how to request
            deletion of such data please forward all inquiries to{" "}
            <a
              className="text-black underline dark:text-blue-400"
              href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#116;&#101;&#97;&#109;&#64;&#103;&#114;&#105;&#100;&#108;&#101;&#121;&#103;&#97;&#109;&#101;&#46;&#99;&#111;&#109;"
            >
              &#116;&#101;&#97;&#109;&#64;&#103;&#114;&#105;&#100;&#108;&#101;&#121;&#103;&#97;&#109;&#101;&#46;&#99;&#111;&#109;
            </a>
            .
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            How Do We Protect Your Information and Secure Information
            Transmissions?
          </h2>
          <p className="mb-4">
            Email is not recognized as a secure medium of communication. For
            this reason, we request that you do not send private information to
            us by email. However, doing so is allowed, but at your own risk.
            Some of the information you may enter on our Web site may be
            transmitted securely via a secure medium known as Secure Sockets
            Layer, or SSL.
          </p>
          <p className="mb-4">
            We may use software programs to create summary statistics, which are
            used for such purposes as assessing the number of visitors to the
            different sections of our site, what information is of most and
            least interest, determining technical design specifications, and
            identifying system performance or problem areas.
          </p>
          <p className="mb-4">
            For site security purposes and to ensure that this service remains
            available to all users, we use software programs to monitor network
            traffic to identify unauthorized attempts to upload or change
            information, or otherwise cause damage.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            A Special Note About Children
          </h2>
          <p className="mb-4">
            Children are not eligible to use our website and services and we ask
            that minors (under the age of 13) do not submit any personal
            information to us. If you are a minor, you can use this site only in
            conjunction with permission and guidance from your parents or
            guardians.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">Policy Changes</h2>
          <p className="mb-4">
            We reserve the right to amend this privacy policy at any time with
            or without notice. However, please be assured that if the Privacy
            Policy changes in the future, we will not use the personal
            information you have submitted to us under this Privacy Policy in a
            manner that is materially inconsistent with this Privacy Policy,
            without your prior consent.
          </p>
          <p className="mb-4">
            We are committed to conducting our business in accordance with these
            principles in order to ensure that the confidentiality of personal
            information is protected and maintained.
          </p>
          <h2 className="mb-4 mt-6 text-xl font-semibold">
            Contact, Opt Out and Data Deletion
          </h2>
          <p className="mb-4">
            If you have any questions regarding this Policy, would like to opt
            out of dealings with our website or request deletion of your account
            and associated data, please contact us via email at{" "}
            <a
              className="text-black underline dark:text-blue-400"
              href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#116;&#101;&#97;&#109;&#64;&#103;&#114;&#105;&#100;&#108;&#101;&#121;&#103;&#97;&#109;&#101;&#46;&#99;&#111;&#109;"
            >
              &#116;&#101;&#97;&#109;&#64;&#103;&#114;&#105;&#100;&#108;&#101;&#121;&#103;&#97;&#109;&#101;&#46;&#99;&#111;&#109;
            </a>
            .
          </p>
        </div>
        {/* {initError && <NetworkError onRetry={init} />} */}
      </main>
    </BasePage>
  );
}
export default PagePrivacyPolicy;

function Breadcrumbs() {
  return (
    <nav className="mb-4 flex px-2" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 rtl:space-x-reverse md:space-x-2">
        <li className="inline-flex items-center">
          <Link href="/" passHref>
            <a
              href="#"
              className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-red-600 dark:text-gray-400 dark:hover:text-white"
            >
              <svg
                className="me-2.5 h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
              </svg>
              Gridley
            </a>
          </Link>
        </li>
        <li aria-current="page">
          <div className="flex items-center">
            <svg
              className="mx-1 h-3 w-3 text-gray-400 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="m1 9 4-4-4-4"
              />
            </svg>
            <span className="ms-1 text-sm font-medium text-gray-500 dark:text-gray-400 md:ms-2">
              Privacy Policy
            </span>
          </div>
        </li>
      </ol>
    </nav>
  );
}
